import { render, staticRenderFns } from "./Borrowers.vue?vue&type=template&id=49f641dd&scoped=true&"
import script from "./Borrowers.vue?vue&type=script&lang=js&"
export * from "./Borrowers.vue?vue&type=script&lang=js&"
import style0 from "./Borrowers.vue?vue&type=style&index=0&id=49f641dd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f641dd",
  null
  
)

component.options.__file = "Borrowers.vue"
export default component.exports